import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { activateStoredTheme } from './utils/theme';

// Stamp the theme on <html> BEFORE the first render so no frame paints in the
// wrong world. Dark is the default and stamps nothing; the stylesheets are
// imported by App.tsx. See utils/theme.ts (TEM-1239).
activateStoredTheme();

// Configure AWS Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true
        },
        preferred_username: {
          required: true
        }
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true
      }
    }
  },
  API: {
    REST: {
      TempestRadioAPI: {
        endpoint: process.env.REACT_APP_API_URL || '',
        region: process.env.REACT_APP_REGION || 'us-east-1'
      }
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_AUDIO_BUCKET || '',
      region: process.env.REACT_APP_REGION || 'us-east-1'
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
